import { Options } from '../../interfaces'
import { Steps } from '../../../../../..'

export function isOrientationPageRefresh(options: Options) {
  const { isRedirectToProgressionPage, step } = options
  return isRedirectToProgressionPage && step === Steps.Orientation
}
